export default __webpack_public_path__ + "static/media/5.ada38652.jpg";